<template>
  <div class="cat-expando-box cat-box expando" :class="_containerclass">
    <component
      :is="_headingTag ? _headingTag : 'div'"
      class="expando-trigger-wrapper"
    >
      <a
        role="button"
        tabindex="0"
        :aria-expanded="open ? 'true' : 'false'"
        :aria-controls="id + '_expando'"
        class="cat-expando-trigger expando-trigger"
        :data-label="open && expandedLabel ? expandedLabel : label"
        :aria-label="
          open && offscreenExpandedLabel
            ? offscreenExpandedLabel
            : offscreenLabel
        "
        @click="expandoClick"
        @keyup.enter="expandoClick"
      >
        <span v-if="icon" class="expando-icon" :class="'icon-' + icon"></span>
        <span
          v-else
          class="expando-icon"
          :class="open ? 'icon-angle-down' : 'icon-angle-right'"
        ></span>
        <span v-if="!open">{{ label }}</span>
        <span v-if="open && !expandedLabel">{{ label }}</span>
        <span v-if="open && expandedLabel">{{ expandedLabel }}</span></a
      >
    </component>
    <cat-hint :id="id + '_hint'" :text="hint" />
    <slot name="html"></slot>
    <div :class="_class">
      <cat-errors :id="id" :errors="errors" :container="true" />
      <transition-expand>
        <div v-show="open" :id="id + '_expando'">
          <slot></slot>
        </div>
      </transition-expand>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatErrors from "@/components/catErrors/catErrors.vue";
import CatHint from "@/components/utilities/hint.vue";
import TransitionExpand from "@/components/utilities/catTransitionExpand.vue";
export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatExpandoBox",
  components: {
    CatErrors,
    CatHint,
    TransitionExpand
  },
  props: {
    id: {
      type: [String, Number],
      description: "Expanding content ID."
    },
    label: {
      type: [String],
      description: "Link label."
    },
    expandedLabel: {
      type: [String],
      description: "Expanded link label."
    },
    offscreenLabel: {
      type: [String],
      description:
        "Accessible name of the trigger button when the content is collapsed."
    },
    offscreenExpandedLabel: {
      type: [String],
      description:
        "Accessible name of the trigger button when the content is expanded."
    },
    hint: {
      type: [String],
      description: "Hint help text."
    },
    titleLevel: {
      type: [Number],
      description:
        "Heading tag h1 to h6 to wrap the button trigger. If not set, a span element is rendered a wrapper of the button trigger."
    },
    icon: {
      type: [String],
      description: "Link icon."
    },
    errors: { type: [Array], description: "Errors list." },
    expanded: { type: [Boolean], description: "Flag to set as expanded" },
    condensed: {
      type: [Boolean],
      default: false,
      description: "Flag to set as collapsed. Default value is false."
    },
    columnindent: {
      type: [Boolean],
      default: false,
      description:
        'Deprecated. Adds the class "column-indent" to the container class. See "alignToValue" props.'
    },
    alignToValue: {
      type: Boolean,
      default: false,
      description:
        "The expando box and its content is shifted to the right such that the expando box is can be aligned with the other read-only attributes values."
    }
  },
  data: function () {
    return {
      open: this.expanded
    };
  },
  watch: {
    expanded: function (newexpanded) {
      this._expanded = newexpanded;
      this.open = newexpanded;
    }
  },
  methods: {
    expandoClick: function (event) {
      this.open = !this.open;
      this.$emit("ui-click", { value: this.open });
    }
  },
  computed: {
    _containerclass: function () {
      return {
        "align-to-value": this.alignToValue,
        "column-indent": this.columnindent,
        condensed: this.condensed,
        "expando-heading": this._headingTag
      };
    },
    _class: function () {
      return {
        expandoContainer: true,
        mini: !this.open
      };
    },
    _headingTag: function (event) {
      let level = this.titleLevel;
      if (this.titleLevel < 1) {
        level = 1;
      } else if (this.titleLevel > 6) {
        level = 6;
      }
      return level ? "h" + level : undefined;
    }
  }
});
</script>
